export default class SearchComponent {
  static CLASSES = {
    SEARCH: 'search',
    SEARCH_NOT_STARTED: 'search--not-started',
    SEARCH_NO_RESULT: 'search--no-result',
    FORM: 'search__form',
    FORM_INPUT: 'search__form__input',
    FORM_RESET: 'search__form__reset',
    FILTER: 'search__filter',
    FILTER_ITEM: 'search__filter__item',
    RESULT: 'search__result',
    MESSAGE: 'search__message'
  };

  static init($search) {
    if (!$search || $search.searchComponent) {
      return;
    }

    $search.searchComponent = new SearchComponent($search);
  }

  static initAll() {
    document.querySelectorAll(`.${SearchComponent.CLASSES.SEARCH}`).forEach(($search) => {
      SearchComponent.init($search);
    });
  }

  constructor($search) {
    this.$search = $search;
    this.$form = $search.querySelector(`.${SearchComponent.CLASSES.FORM}`);
    this.$formInput = $search.querySelector(`.${SearchComponent.CLASSES.FORM_INPUT}`);
    this.$formReset = $search.querySelector(`.${SearchComponent.CLASSES.FORM_RESET}`);

    this.onClickFormReset = this.onClickFormReset.bind(this);

    this.init();
  }

  init() {
    this.$formReset.addEventListener('click', this.onClickFormReset);
  }

  destroy() {
    this.$formReset.removeEventListener('click', this.onClickFormReset);
    this.$search.searchComponent = null;
  }

  onClickFormReset() {
    this.reset();
    this.$formReset.blur();
  }

  reset() {
    this.$formInput.value = '';
  }
}
